import { mergeStyles } from '@fluentui/react';
import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../App/store';
import { accountsSlice } from '../slice';
import AccountSearch from './AccountSearch';
import AddAccount from './AddAccount';
import UpdateAccount from './UpdateAccount';

export default (props?: { isFullWidth?: boolean; noReset?: boolean }) => {
  const activeAccountId = useAppSelector(
    (state) => state.accounts.activeAccountId
  );
  const promptAddAccount = useAppSelector(
    (state) => state.accounts.promptAddAccount
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!props?.noReset) {
      dispatch(resetAccountsState);
    }
  }, [props?.noReset]);

  return (
    <div className={!props?.isFullWidth ? containerStyle : ""}>
      {promptAddAccount ? (
        <AddAccount />
      ) : activeAccountId ? (
        <UpdateAccount />
      ) : (
        <AccountSearch />
      )}
    </div>
  );
};

export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const resetAccountsState = accountsSlice.actions.reset();
const containerStyle = mergeStyles({
  maxWidth: "calc(10vw + 400px)",
  marginLeft: "50%",
  transform: "translateX(-50%)",
  padding: "12px",
});
